export const getLocalStorage = (key) => {
  // if (localStorage.hasOwnProperty(key)) {
  //   const local = localStorage.getItem(key);
  //   return JSON.parse(local);
  // } else {
  //   return {};
  // }
  return JSON.parse(localStorage.getItem(key));
};

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorage = (key) => {
  localStorage.removeItem(key);
};
